import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { AttachmentItem } from './AttachmentItem';
import { DragZone } from './DragZone';

import arrowIcon from '../../../../assets/claimbot/upload-circle.svg';

import {
  ACCEPTED_FILES,
} from '../../../../constants';

import './AttachmentSelector.css';

const AttachmentSelector = ({
  attachments = [],
  maxAttachmentSizeReached = false,
  onAddAttachment = () => { },
  onRemoveAttachment = () => { },
}) => {
  const addFilesInputRef = useRef();
  const { t } = useTranslation('fileClaimbot');

  const addFiles = (files) => {
    const fileList = Array.from(files);
    onAddAttachment(fileList);
  };

  const handleFileChange = (event) => {
    addFiles(event.target.files);
  };

  // handles visual and interactuable button events
  // (from mouse or keyboard) and then triggers
  // the event from hidden not customizable file input type
  const onFakeButtonClick = () => {
    addFilesInputRef.current?.click();
  };

  return (
    <div className="File-claimbot-attachment-selector-container">
      <div className="File-claimbot-attachment-drag-zone-card">
        <DragZone attachments={attachments} onAddFiles={addFiles} />

        <img alt="" src={arrowIcon} />

        <span>
          {t('attachments.dragAndDropOr')}

          <label htmlFor="choseFileAttachments">
            <input
              ref={addFilesInputRef}
              accept={ACCEPTED_FILES}
              id="choseFileAttachments"
              multiple
              onChange={handleFileChange}
              type="file"
              value=""
            />

            <button
              onClick={onFakeButtonClick}
              type="button"
            >
              {t('attachments.chooseFile')}
            </button>
          </label>

          {t('attachments.toUpload')}
        </span>

        <span>{t('attachments.fileLimit')}</span>
      </div>

      {attachments.length > 0
        ? (
          <h3
            className="File-claimbot-attachment-selector-uploaded-files-title"
          >
            {t('attachments.uploadedFiles')}
          </h3>
        )
        : null}

      {attachments.map((att) => (
        <AttachmentItem
          key={String(att.key)}
          attachment={att}
          onRemoveAttachment={onRemoveAttachment}
          t={t}
        />
      ))}

      {/* WIP: pending french translation validation */}
      {maxAttachmentSizeReached ? (
        <span className="File-claimbot-attachment-selector-total-error">
          {t('attachments.totalSizeReached')}
        </span>
      ) : null}
    </div>
  );
};

export { AttachmentSelector };
